import type { JSX } from 'react'

export const BundleCover4 = (): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    fill='none'
    viewBox='0 0 1920 1080'
    preserveAspectRatio='none'
  >
    <rect width='1920' height='1080' fill='#161616' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M928.21 0C925.451 6.24176 922.608 12.6452 919.692 19.2122L919.692 19.2126C874.854 120.204 812.852 259.855 776 444.5C734.557 652.145 646.5 841.499 568.5 978.499C546.626 1016.92 527.881 1051.01 512.3 1080H687.655C689.951 1075.93 692.326 1071.73 694.775 1067.41C744.033 980.404 823.318 840.367 895.5 561.5C948.119 358.214 1032.56 133.215 1092.63 0H928.21Z'
      fill='url(#paint0_linear_628_255)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 931.89C37.9386 897.297 93.7653 850.054 175 787.5C333.368 665.552 518.225 621.704 729.406 571.613C900.935 530.927 1089.83 486.121 1296 392C1589.21 258.143 1778.31 100.162 1871.38 0H1628.81C1593.13 32.6548 1526.28 85.8006 1413 163C1226.71 289.957 890.327 375.945 605.806 448.676L605.803 448.676C547.439 463.596 491.256 477.957 439 492C244.664 544.224 87.8117 645.179 0 716.839V931.89Z'
      fill='url(#paint1_linear_628_255)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_628_255'
        x1='805.488'
        y1='-126.427'
        x2='805.488'
        y2='1183.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#212B53' />
        <stop offset='1' stopColor='#171617' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_255'
        x1='924.25'
        y1='-64'
        x2='924.25'
        y2='1011.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#232C51' />
        <stop offset='1' stopColor='#262526' />
      </linearGradient>
    </defs>
  </svg>
)
